import { CSSProperties, ReactElement, useEffect } from "react";
import { ILadle, IPanelProps, IRefractories } from "./types";
import { cloneObject } from "../../../../system/utils";
import RowComponent from "../../components/rowComponent";
import TextField from "@mui/material/TextField";
import { useAsyncFetch } from "../../../../system/useFetch";
import { IEntityBase } from "../../../../types";
import { Paper } from "@mui/material";

const ladleGridStyle = {
  gridTemplateColumns: "20% 20% 1fr"
};

const titleCellStyle = (): CSSProperties => ({
  padding: ".5em",
  alignSelf: "stretch",
  borderRadius: 5,
  background: "rgba(50, 50, 50, .3)"
});


const RefractoriesPanel = ({ value, property, onChange }: IPanelProps<IRefractories>): ReactElement => {
  const [ dispatchAPI ] = useAsyncFetch<IEntityBase[]>();

  useEffect(() => {
    if (value.ladles.length === 0) {
      dispatchAPI({
        module: "meltShop",
        query: "getLadles",
        payload: {
          areaID: 1
        }
      }).then(response => {
        if (response) {
          value.ladles = response.map(l => ({
            ladle: l.name,
            status: "",
            heats: 0,
            contactTime: 0 }));


          onChange(property, { ...value });
        }
      });
    }
  }, [value]);

  const onChangeData = (prop: keyof IRefractories, subProp: string, newValue: any) => {
    const newObj = cloneObject(value);

    if (prop === "tundishes") {
      (newObj.tundishes as any)[subProp] = newValue;
    } else if (prop === "ladleAvailables") {
      (newObj.ladleAvailables as any)[subProp] = newValue;
    }

    onChange(property, newObj);
  };

  const onChangeLadle = (ladle: string, prop: keyof ILadle, newValue: any) => {
    const newObj = cloneObject(value);

    newObj.ladles = newObj.ladles.map(l => {
      if (l.ladle === ladle) {
        if (prop === "heats") {
          l.heats = newValue;
        } else if (prop === "contactTime") {
          l.contactTime = newValue;
        } else if (prop === "status") {
          l.status = newValue;
        }
      }

      return l;
    });

    onChange(property, newObj);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Tundishes (#)" ratio={.2} >
        <div className="row-content-2">
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            type="number"
            value = {value.tundishes.value}
            fullWidth={true}
            onChange={event => onChangeData("tundishes", "value", event.target.value)}
          />
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.tundishes.comment}
            fullWidth={true}
            onChange={event => onChangeData("tundishes", "comment", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Ladle availables (#)" ratio={.2} >
        <div className="row-content-2">
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            type="number"
            value = {value.ladleAvailables.value}
            fullWidth={true}
            onChange={event => onChangeData("ladleAvailables", "value", event.target.value)}
          />
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.ladleAvailables.comment}
            fullWidth={true}
            onChange={event => onChangeData("ladleAvailables", "comment", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Ladle" ratio={.2} >
        <div className="row-content-3" style={ladleGridStyle}>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div className="align-self-center justify-self-center display-grid">
              <strong >Heats</strong>
            </div>
          </Paper>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div className="align-self-center justify-self-center display-flex-column">
              <strong >Contact Time</strong>
            </div>
          </Paper>
          <Paper elevation={0}  style={titleCellStyle()} className="flex-grow-1">
            <div className="align-self-center justify-self-center display-flex-column">
              <strong >Status</strong>
            </div>
          </Paper>
        </div>
      </RowComponent>

      { value.ladles.map(ladle => {

        return (
          <RowComponent key={`ladle-${ladle.ladle}`} title={ladle.ladle} ratio={.2} >
            <div className="row-content-3" style={ladleGridStyle}>
              <TextField
                variant="outlined"
                placeholder="to be filled..."
                type="number"
                value = {ladle.heats}
                fullWidth={true}
                onChange={event => onChangeLadle(ladle.ladle, "heats", event.target.value)}
              />
              <TextField
                variant="outlined"
                placeholder="to be filled..."
                type="number"
                value = {ladle.contactTime}
                fullWidth={true}
                onChange={event => onChangeLadle(ladle.ladle, "contactTime", event.target.value)}
              />
              <TextField
                variant="outlined"
                placeholder="to be filled..."
                multiline={true}
                minRows={4}
                maxRows={4}
                value = {ladle.status}
                fullWidth={true}
                onChange={event => onChangeLadle(ladle.ladle, "status", event.target.value)}
              />
            </div>
          </RowComponent>
        );
      })}
    </div>
  );
};

export default RefractoriesPanel;